/**
 * 获取上报用的 filetype
 */
export function getFileTypeForReport() {
    var fileTypeStr = getFileTypeStrForReport();
    return fileTypeStr;
}
export function getFileTypeStrForReport() {
    var _a, _b, _c;
    var padType = ((_c = (_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.padInfo) === null || _c === void 0 ? void 0 : _c.padType) || getClientVars().padType;
    return padType;
}
export function getBasicClientVars() {
    return window.basicClientVars;
}
export function getClientVars() {
    var _a;
    // @ts-ignore
    return (_a = window.clientVars) !== null && _a !== void 0 ? _a : {};
}
